import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';
import PageLoader from './components/PageLoader';

// Import Pages
import Home from './pages/Home';
import About from './pages/About';
import Divisions from './pages/Divisions';
import GeneratorSales from './pages/GeneratorSales';
import GeneratorRental from './pages/GeneratorRental';
import GeneratorMaintenance from './pages/GeneratorMaintenance';
import GeneratorProductDetail from './pages/GeneratorProductDetail';
import GeneratorSolutionsOverview from './pages/GeneratorSolutionsOverview';
import SolarSolutions from './pages/SolarSolutions';
import ElectricalPanels from './pages/ElectricalPanels';
import CuttingTools from './pages/CuttingTools';
import TelecomServices from './pages/TelecomServices';
import Gallery from './pages/Gallery';
import Clients from './pages/Clients';
import Careers from './pages/Careers';
import Contact from './pages/Contact';

// Admin Pages
import AdminLogin from './pages/admin/AdminLogin';
import AdminPanel from './pages/admin/AdminPanel';

// ScrollToTop Utility
function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
    } else {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        // Delay scroll slightly to allow DOM rendering
        const timer = setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
        return () => clearTimeout(timer);
      }
    }
  }, [pathname, hash]);

  return null;
}

function AppContent() {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');

  return (
    <div className="flex flex-col min-h-screen bg-light">
      {/* Navigation Header */}
      {!isAdminPath && <Header />}

      {/* Page Routing */}
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/divisions" element={<Divisions />} />
          <Route path="/generator-solutions" element={<GeneratorSales />} />
          <Route path="/generator-sales" element={<GeneratorSales />} />
          <Route path="/generator-rental" element={<GeneratorRental />} />
          <Route path="/generator-maintenance" element={<GeneratorMaintenance />} />
          <Route path="/generator-product/:id" element={<GeneratorProductDetail />} />
          <Route path="/generator-solutions-overview" element={<GeneratorSolutionsOverview />} />
          <Route path="/solar-solutions" element={<SolarSolutions />} />
          <Route path="/electrical-panels" element={<ElectricalPanels />} />
          <Route path="/cutting-tools" element={<CuttingTools />} />
          <Route path="/telecom" element={<TelecomServices />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/clients" element={<Clients />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />

          {/* Admin Routing */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminPanel />} />
        </Routes>
      </main>

      {/* Global Dark Footer */}
      {!isAdminPath && <Footer />}

      {/* Floating Actions Overlay (WhatsApp, Call, Scroll to Top) */}
      {!isAdminPath && <FloatingCTA />}
    </div>
  );
}

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoaderFinish = () => {
    setIsLoading(false);
  };

  return (
    <>
      {isLoading && <PageLoader onFinish={handleLoaderFinish} />}
      <Router>
        <ScrollToTop />
        <AppContent />
      </Router>
    </>
  );
}

export default App;
